module.exports = __webpack_public_path__ + "img/arthrose.0ec99e4e.jpg";